
// FancyDressActivity
import React from 'react';
import FieldTrip32025 from 'views/FieldTrip32025';

const FancyDressActivityPage = () => {
  return <FieldTrip32025/>;
};

export default FancyDressActivityPage;